import React from 'react';

/**
 * ExportControls - Export format selector and download button.
 * Renders a dropdown to choose CSV/Excel and a button to trigger export.
 */
const ExportControls = ({
  exportFormat,
  setExportFormat,
  handleExport,
  exportLoading,
  loading,
  hasData,
}) => {
  if (!hasData) return null;

  return (
    <div className="export-controls">
      <select
        value={exportFormat}
        onChange={(e) => setExportFormat(e.target.value)}
        className="export-format-select"
      >
        <option value="csv">CSV</option>
        <option value="xlsx">Excel</option>
      </select>
      <button
        onClick={handleExport}
        disabled={exportLoading || loading}
        className="export-button"
      >
        {exportLoading ? '⏳ Exporting...' : '📥 Download Results'}
      </button>
    </div>
  );
};

export default ExportControls;
